import { Injectable } from '@angular/core';
import { DateTime } from 'luxon';
import { BannerNotificationsService } from '../../xform-compat';
import { UserGroupsService } from '../data-services';
import { UserService } from '../data-services';
import { CONFIG } from '../../config';


/**
 * Singleton service for alert utils
 */
@Injectable({
  providedIn: 'root'
})
export class AlertsService {

  constructor(
    private userGroupService: UserGroupsService,
    private userService: UserService,
    private bannerNotificationService: BannerNotificationsService
  ) { }

  /**
   * Search against the API and filters the list of possible options for the assignedTo drop down
   * @param {string} query: search term
   * @param {(responseRecords: Array<any>) => void} callback: list of found records
   */
  public searchAssignedTo (query: string, callback: (responseRecords: Array<any>) => void) {
    let tempList = [];
    this.userGroupService.getRecords({filter: query}, true).subscribe(
      userGroupsRecords => {
        tempList = this.getConvertedItems(userGroupsRecords);
        this.userService.getRecords({filter: query}, true).subscribe(
          userRecords => {
            userRecords.forEach(user => {
              user.raw = {id: user.id, isUserGroup: false};
              tempList.push(user);
            });
            callback(tempList);
          },
          error1 => this.bannerNotificationService.error(error1)
        );
      },
      error => this.bannerNotificationService.error(error)
    );
  }

  /**
   * Transforms data to merge arrays of users and usergroups in a single array
   * @param {Array<any>} list: list of user groups
   * @returns {Array<any>}: new converted list
   */
  public getConvertedItems (list: Array<any>): Array<any> {
    list.map(userGroup => {
      userGroup.fullName = userGroup.name;
      userGroup.isUserGroup = true;
      userGroup.raw = JSON.stringify({id: userGroup.id, isUserGroup: true});
    });
    return list;
  }

  /**
   * Transform form data before form submission to match fields in the API
   * @param form: form data to convert
   * @returns {any}: new converted data
   */
  public getFormattedData (form: any, ampm: string = 'am') {
    const timeStr: string = form.value.alertHour || '';
    form.value.alert = {};
    form.value.alert.manualAlert = {};
    form.value.alert.userGroupIds = [];
    form.value.alert.userIds = [];
    form.value.alert.alertType = 'MANUAL';

    if (!form.value.date || !timeStr) {
      return form;
    }
    const parts = timeStr.split(':');
    let hours = parseInt(parts[0], 10) || 0;
    const minutes = parseInt(parts[1], 10) || 0;
    if (ampm === 'pm' && hours < 12) {
      hours += 12;
    } else if (ampm === 'am' && hours === 12) {
      hours = 0;
    }
    const dateTime =
      (form.value.date as DateTime).set({ hour: hours, minute: minutes }).toUTC();

    form.value.alert.alertTriggerDatetime = dateTime.toFormat(CONFIG.dateTimeServerFormat);
    form.value.alert.manualAlert.alertText = form.value.description;
    form.value.assignedTo.forEach(item => {
      if (item.firstName) {
        form.value.alert.userIds.push(item.id);
      } else {
        form.value.alert.userGroupIds.push(item.id);
      }
    });

    form.value.alert.addPrimary = form.value.addPrimary;
    form.value.alert.addSecondary = form.value.addSecondary;
    form.value.alert.repeatAlert = form.value.repeatAlert;
    form.value.alert.alertFrequency = form.value.alertFrequency;
    form.value.alert.indefiniteInstance = form.value.indefiniteInstance;
    form.value.alert.instanceCount = form.value.instanceCount;

    return form;
  }

}
